import { ItemWithId } from 'services/constants/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { EIconButtons } from 'services/constants/iconsTypes';

export type TNotificationSettingsTableRow = ItemWithId & {
	name: string;
	email: string;
	role: string;
	enabled: boolean;
	firstName: string;
	lastName: string;
};

export const tableStructure: TTableStructure<keyof TNotificationSettingsTableRow>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TNotificationSettingsTableRow,
		show: false,
		sortable: true,
		filterable: true,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'First Name',
		selector: 'firstName' as keyof TNotificationSettingsTableRow,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Last Name',
		selector: 'lastName' as keyof TNotificationSettingsTableRow,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Email',
		selector: 'email' as keyof TNotificationSettingsTableRow,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Role',
		selector: 'role' as keyof TNotificationSettingsTableRow,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['Dashboard', 'Dashboard access'],
			['Notifications only', 'Notifications only'],
		],
		colors: [
			['Dashboard', 'warning.light'],
			['Notifications only', 'info.light'],
		],
		colSpan: 1,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TNotificationSettingsTableRow,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		buttonFilter: (item: TNotificationSettingsTableRow) => {
			switch (item.enabled) {
				case true:
					return [
						{ name: 'Notifications', icon: EIconButtons.NOTIFICATION },
						// { name: 'Edit', icon: EIconButtons.EDIT },
						// { name: 'Delete', icon: EIconButtons.DELETE },
					];
				default:
					return [
						{ name: 'Delete', icon: EIconButtons.DELETE, color: 'error.main' },
						{ name: 'Edit', icon: EIconButtons.EDIT },
						{ name: 'Notifications', icon: EIconButtons.NOTIFICATION },
					];
			}
		},
	},
];
